import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  diagram: { id: 'Diagram', defaultMessage: 'Diagram' },
  kind: { id: 'diagram-kind', defaultMessage: 'Diagram kind' },
  caption: { id: 'diagram-caption', defaultMessage: 'Caption' },
  source: { id: 'diagram-source', defaultMessage: 'Diagram source' },
});

export const diagramSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.diagram),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['kind', 'caption'] }],
  properties: {
    kind: {
      title: intl.formatMessage(messages.kind),
      choices: [['mermaid', 'Mermaid']],
      default: 'mermaid',
    },
    caption: { title: intl.formatMessage(messages.caption) },
  },
  required: [],
});
